import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Sysuser } from '../entity/Sysuser-angular';


@Injectable({
  providedIn: 'root'
})
export class SysuserServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '' ;
    this.defaultItem = new Sysuser();
    this.entityType.type = EntityType.data;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
        UserID : '登入者代號' , UserName : '登入者名稱' , Password : '密碼' , PS : '可登入公司' , EMAIL : 'E-Mail帳號' , CUSTOMER : '客戶代號' , VENDOR : '廠商代號' , WA008 : '最後登入時間' , WA009 : '部門代號' , WA010 : '主要代理人' , WA011 : '主管代號' , WA012 : '停用日期' , WA013 : '員工編號' , WA014 : '起始代理日期' , WA015 : '結束代理日期' , WA016 : '代理人員工號'  };

    this.fieldNames = 'UserID,UserName,Password,PS,EMAIL,CUSTOMER,VENDOR,WA008,WA009,WA010,WA011,WA012,WA013,WA014,WA015,WA016' ;
    this.fieldLengths = {UserID : 10 ,UserName : 10 ,Password : 36 ,PS : 255 ,EMAIL : 200 ,CUSTOMER : 10 ,VENDOR : 10 ,WA008 : 0 ,WA009 : 6 ,WA010 : 10 ,WA011 : 10 ,WA012 : 8 ,WA013 : 10 ,WA014 : 8 ,WA015 : 8 ,WA016 : 10 } ;
    this.columnDefs = [
      { field: "VENDOR", headerName: "廠商代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WA013", headerName: "員工編號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WA011", headerName: "主管代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WA010", headerName: "主要代理人",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WA009", headerName: "部門代號",headerTooltip: "",width:118,cellDataType: "text", },
      { field: "UserID", headerName: "登入者代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WA016", headerName: "代理人員工號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "CUSTOMER", headerName: "客戶代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "EMAIL", headerName: "E-Mail帳號",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "PS", headerName: "可登入公司",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "Password", headerName: "密碼",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "UserName", headerName: "登入者名稱",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WA012", headerName: "停用日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "WA014", headerName: "起始代理日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "WA015", headerName: "結束代理日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "WA008", headerName: "最後登入時間",headerTooltip: "",width:80,cellDataType: "date", valueFormatter: (p:any) => { return jkLib.datetimeFormatter(p.value)},  },
    ];
    this.columnDefsVir = [
      { field: "CUSTOM_NAME", headerName: "客戶簡稱",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "VENDOR_NAME", headerName: "簡稱",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WA009C", headerName: "部門名稱",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WA013C", headerName: "姓名",headerTooltip: "",width:150,cellDataType: "text", },
    ];
    this.tableName = 'SYSUser' ;
    this.isSys =true;
    this.sqlSelect = `SELECT SYSUser.*,
 A.MA002 AS CUSTOM_NAME,B.MA002 AS VENDOR_NAME,C.MV002 AS WA013C,D.ME002 AS WA009C
 FROM SYSUser
 LEFT JOIN $$COPMA AS A ON CUSTOMER=A.MA001
 LEFT JOIN $$PURMA AS B ON VENDOR=B.MA001
 LEFT JOIN $$CMSMV AS C ON C.MV001=WA013
 LEFT JOIN $$CMSME AS D ON D.ME001=WA009
` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY UserID` ;
    this.keyFields = ['UserID'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['UserID'];
    this.seqField = '' ;
    this.seqFieldLength = 4 ;
  }
  override async validateItem(item: Sysuser): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Sysuser): Promise<Sysuser> {
    await super.newRecord(newItem);
    return newItem;
  }


}

